import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { useActions } from 'src/hooks/useActions';
import { scrollToTop } from 'src/common/utils/others';
import { OrderState } from 'src/store/reducers/order/types';
import { IClientFetch } from 'src/models/IOrder';

interface IProps {
  step: number;
  setStep: (step: number) => void;
}

const SwitchStep: FC<IProps> = ({ step, setStep }) => {
  const navigate = useNavigate();
  const { initOrder, changeOrder } = useActions();
  const order = useTypedSelector(state => state.order);

  const onDataChange = (name: string, value: any) => changeOrder(name, value);

  const handleClearOrder = () => {
    initOrder();
    setStep(0);
    navigate('/');
    scrollToTop();
  };

  const _renderCurrentStep = (): JSX.Element | undefined => {
    switch (step) {
      case 0:
        return (
          <Step1
            order={order}
            onChange={onDataChange}
            setStep={setStep}
            handleClearOrder={handleClearOrder}
          />
        );
      case 1:
        return <Step2 order={order} onChange={onDataChange} setStep={setStep} />;
      case 2:
        return (
          <Step3
            order={order as OrderState & { client: IClientFetch }}
            onChange={onDataChange}
            setStep={setStep}
          />
        );
      default:
        return (
          <Step1
            order={order}
            onChange={onDataChange}
            setStep={setStep}
            handleClearOrder={handleClearOrder}
          />
        );
    }
  };

  return <>{_renderCurrentStep()}</>;
};

export default SwitchStep;
